var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640.3 731.2",
    style: {
      enableBackground: "new 0 0 640.3 731.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#E0A962;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_834",
    className: "st0",
    d: "M0.6,0.6c0,0,208.6,22.8,323.9,166.4c0,0,106.2-118.6,315.1-128.6L505,616.2l-83,27.2 c0,0,46.5-356.1,53.6-410.4c-39.7,32.5-92.5,66.2-99.3,192.6c-10.1,188-12.7,237.5-12.7,237.5L287,689.3c0,0-8.7-161.4-14.4-268.1 c-4.9-91.9-24.1-149.4-101.4-206.3l64.3,492.4l-64.6,23.2L0.6,0.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM);
export default __webpack_public_path__ + "static/media/M.ca9fb168e40070492c636401270e923a.svg";
export { ForwardRef as ReactComponent };